import { ERCText } from 'components/text'
import React from 'react'
import styles from './recommended.module.scss'

const RecommendedCourses = ({ img, title, category }) => {

    return (
        <div className={styles.body} >
            <img src={img} alt='' />
            <div className={styles.content} >
                <ERCText size='12px' weight='600' lHeight='18px' >{title}</ERCText>
                <ERCText color='#FFD600' size='12px' weight='600' lHeight='18px' >{category}</ERCText>
            </div>
        </div>
    )
}

export default RecommendedCourses